import { render, staticRenderFns } from "./ModalCadastroResponsavel.vue?vue&type=template&id=95977644"
import script from "./ModalCadastroResponsavel.vue?vue&type=script&lang=js"
export * from "./ModalCadastroResponsavel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports